import React from "react";

class AdSpace extends React.Component {
    componentDidMount() {
        setTimeout(() => {
            this.setState({ loading: false });
        }, 1000);
    }

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            timeLoaded: Math.floor(Date.now() / 1000)
        };
    }

    render() {
        if (!this.state.loading) {
            return (
                <div className="ad-space-container col-lg-4 col-xs-6">
                    <style>
                        {`
                    .ad-space {
                        display: none
                    }

                    @media (min-width: 768px) {
                        .ad-space-container{
                            display: flex;
                            justify-content: center;
                            background: #F2F2F2;
                            padding: 0;
                        }
                        .ad-space-container iframe{
                            border: none;
                            outline: none;
                        }
                        .ad-space {
                            display: flex;
                            padding: 1px;
                            text-align: center;
                            width: 302px;
                            flex-direction: column;
                            justify-content: space-around;
                        }
                        .advertisement-text{
                            color: #BABABA;
                            font-size: 8px;
                            font-weight: bold;
                            letter-spacing: 2px;
                            display: block;
                        }
                    }
                `}
                    </style>
                    <div className="ad-space">
                        <iframe
                            src={`https://ad.doubleclick.net/ddm/adi/N718679.3040413THENOUNPROJECT.CO/B22121483.248201635;sz=300x250;ord=[${
                                this.state.timeLoaded
                            }];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?`}
                            width="300"
                            height="250"
                            marginWidth="0"
                            marginHeight="0"
                            allowtransparency="1"
                            frameBorder="0"
                            scrolling="no"
                        >
                            <script
                                src={`https://ad.doubleclick.net/ddm/adi/N718679.3040413THENOUNPROJECT.CO/B22121483.248201635;sz=300x250;ord=[${Math.floor(
                                    Date.now() / 1000
                                )}];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?`}
                            />
                        </iframe>
                        <span className="advertisement-text">
                            ADVERTISEMENT
                        </span>
                    </div>
                </div>
            );
        } else {
            return <div>Loading...</div>;
        }
    }
}

export default AdSpace;
